/**
 * Tabs is a custom HTML element that creates a tabbed interface.
 * 
 * Usage:
 * Include the following HTML structure inside the <tabs> element.
 * Example:
 * 
 * <tabs-component>
 *   <div class="tab-header">
 *     <div class="tab-button active" data-shift-fix="Tab 1" data-target="tab1">Tab 1</div>
 *     <div class="tab-button" data-shift-fix="Tab 2" data-target="tab2">Tab 2</div>
 *   </div>
 *   <div class="tab-content active" id="tab1">Content for Tab 1</div>
 *   <div class="tab-content" id="tab2">Content for Tab 2</div>
 * </tabs-component>
 */

class Tabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeTabs();

    if (this.classList.contains('collection-filters')) {
      this.centerActiveTab();
    }
  }

  initializeTabs() {
    const tabButtons = this.querySelectorAll('.tab-button');
    const tabContents = this.querySelectorAll('.tab-content');

    tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.handleTabClick(button, tabButtons, tabContents);
      });
    });

    // Set default active tab
    // if (tabButtons.length > 0) {
    //   tabButtons[0].classList.add('active');
    //   tabContents[0].classList.add('active');
    // }
  }

  centerActiveTab() {
    const container = this.querySelector('.tab-header');
    const activeTab = this.querySelector('.tab-button.active');
    if (!container || !activeTab) return;

    const containerRect = container.getBoundingClientRect();
    const targetRect = activeTab.getBoundingClientRect();
    const targetLeft = (targetRect.left - containerRect.left) + container.scrollLeft;

    container.scrollTo({
      left: targetLeft - containerRect.width / 2 + targetRect.width / 2,
      behavior: 'auto'
    });
  }

  handleTabClick(button, tabButtons, tabContents) {
    tabButtons.forEach(btn => btn.classList.remove('active'));
    tabContents.forEach(content => content.classList.remove('active'));

    button.classList.add('active');
    const targetContent = this.querySelector(`#${button.dataset.target}`);
    if (targetContent) {
      targetContent.classList.add('active');
    }
  }
}

customElements.define('tabs-component', Tabs);
